import { IAddress, IContact } from '@mavles/contacts';
import { IOrderLineItem } from './order-line-items';

export interface IOrder {
  order_id: number;
  order_number: number;
  contact_id: number;
  account_id: number;
  order_date: Date;
  element_code: string;
  element_local_code: string;

  order_line_items: IOrderLineItem[];
  order_subtotal: number;
  order_discount_amount: number;
  order_adjustment_amount: number;
  order_total: number;

  order_address_id: number;

  order_conditions: string;
  order_notes: string;

  created_at: Date;
  created_by: number;
  updated_by: number;
  updated_at: Date;
}

export interface IOrderSearch extends IOrder {
  order_address: IAddress;
  contact: IContact | undefined;
  master_id: number;
  element_id: number;
  element_code: string;
  element_local_code: string;
  contact_type: string;
  name: string;
}

export class Order implements IOrder {
  contact_id!: number;
  order_id!: number;
  account_id!: number;
  order_number!: number;
  element_code!: string;
  element_local_code!: string;
  order_date = new Date();
  order_line_items!: IOrderLineItem[];
  order_subtotal = 0;
  order_discount_amount = 0;
  order_adjustment_amount = 0;
  order_total = 0;
  order_address_id!: number;
  order_conditions!: string;
  order_notes!: string;
  created_at!: Date;
  updated_at!: Date;
  created_by!: number;
  updated_by!: number;
}
